export type ProspectGroupByMode = 'day' | 'week' | 'month' | 'none';

export function toLocalDateKey(date: Date, timeZone?: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const year = parts.find((part) => part.type === 'year')?.value;
  const month = parts.find((part) => part.type === 'month')?.value;
  const day = parts.find((part) => part.type === 'day')?.value;
  return `${year}-${month}-${day}`;
}

export function isSameLocalCalendarDay(date: Date, now: Date, timeZone?: string): boolean {
  return toLocalDateKey(date, timeZone) === toLocalDateKey(now, timeZone);
}

function getStartOfWeek(date: Date): Date {
  const start = new Date(date);
  const day = start.getDay();
  const diff = start.getDate() - day + (day === 0 ? -6 : 1);
  start.setDate(diff);
  start.setHours(0, 0, 0, 0);
  return start;
}

export function getGroupKeyAndLabel(
  date: Date,
  mode: ProspectGroupByMode,
  timeZone?: string,
): { key: string; label: string } {
  const localeOpts = timeZone ? { timeZone } : {};
  if (mode === 'day') {
    return {
      key: toLocalDateKey(date, timeZone),
      label: date.toLocaleDateString(undefined, {
        ...localeOpts,
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      }),
    };
  }
  if (mode === 'week') {
    const start = getStartOfWeek(date);
    const end = new Date(start);
    end.setDate(end.getDate() + 6);
    const startStr = start.toLocaleDateString(undefined, { ...localeOpts, month: 'short', day: 'numeric' });
    const endStr = end.toLocaleDateString(undefined, {
      ...localeOpts,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
    return { key: toLocalDateKey(start, timeZone), label: `Week of ${startStr} – ${endStr}` };
  }
  if (mode === 'month') {
    return {
      key: toLocalDateKey(date, timeZone).slice(0, 7),
      label: date.toLocaleDateString(undefined, { ...localeOpts, month: 'long', year: 'numeric' }),
    };
  }
  return { key: 'all', label: 'All Prospects' };
}
